import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  scopeItem: {},
  scopeItems: [],
  overviewLoader: false,
  scopeLoading: false,
  scopesLoading: false,
  scopeStatusLoading: false,
  scopePagination: {},
  tasks: [],
  tasksLoading: false,
  taskLoading: false,
  taskPagination: {},
  error: "",
  resourceShifts: [],
  resourceCapacity: [],
  resourcesMonitor: [],
  resourceShiftsLoading: false,
  resourcesMonitorLoading: false,
});

export default function scopeReducer(state = initialState, action) {
  switch (action.type) {
    // GET SCOPE ITEMS
    case ACTIONS.SCOPE.PENDING: {
      return state.set("error", "").set("scopesLoading", true);
    }
    case ACTIONS.SCOPE.SUCCESS: {
      return state
        .set("error", "")
        .set("scopeItems", action.data.data)
        .set("scopePagination", action.data.pagination)
        .set("scopesLoading", false);
    }
    case ACTIONS.SCOPE.ERROR: {
      return state.set("scopesLoading", false).set("error", action.error);
    }

    // GET SCOPE DETAILS
    case ACTIONS.SCOPE_DETAILS.PENDING: {
      return state.set("error", "").set("overviewLoader", true);
    }
    case ACTIONS.SCOPE_DETAILS.SUCCESS: {
      return state
        .set("overviewLoader", false)
        .set("error", "")
        .set("scopeItem", action.data);
    }
    case ACTIONS.SCOPE_DETAILS.ERROR: {
      return state.set("overviewLoader", false).set("error", action.error);
    }

    // UPDATE SCOPE
    case ACTIONS.UPDATE_SCOPE.PENDING: {
      return state.set("scopeStatusLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_SCOPE.SUCCESS: {
      if (action.data.type === "overview") {
        return state
          .set("error", "")
          .set("scopeStatusLoading", false)
          .set("scopeItem", action.data.data);
      } else {
        return state
          .set("error", "")
          .set("scopeStatusLoading", false)
          .set("scopeItems", action.data.data)
          .set("scopePagination", action.data.pagination);
      }
    }
    case ACTIONS.UPDATE_SCOPE.ERROR: {
      return state.set("error", action.error).set("scopeStatusLoading", false);
    }

    // CREATE SCOPE
    case ACTIONS.CREATE_SCOPE.PENDING: {
      return state.set("scopeStatusLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_SCOPE.SUCCESS: {
      return state
        .set("scopeStatusLoading", false)
        .set("error", "")
        .set("scopeItems", action.data.data)
        .set("scopePagination", action.data.pagination);
    }
    case ACTIONS.CREATE_SCOPE.ERROR: {
      return state.set("error", action.error).set("scopeStatusLoading", false);
    }

    // DELETE SCOPE
    case ACTIONS.DELETE_SCOPE.PENDING: {
      return state.set("scopeStatusLoading", true);
    }
    case ACTIONS.DELETE_SCOPE.SUCCESS: {
      return state
        .set("error", "")
        .set("scopeStatusLoading", false)
        .set("scopeItems", action.data.data)
        .set("scopePagination", action.data.pagination);
    }
    case ACTIONS.DELETE_SCOPE.ERROR: {
      return state.set("scopeStatusLoading", false).set("error", action.error);
    }

    // SORT SCOPE ITEMS
    case ACTIONS.SORT_SCOPEITEMS.PENDING: {
      return state.set("error", "").set("scopesLoading", true);
    }
    case ACTIONS.SORT_SCOPEITEMS.SUCCESS: {
      return state
        .set("error", "")
        .set("scopesLoading", false)
        .set("scopeItems", action.data.data)
        .set("scopePagination", action.data.pagination);
    }
    case ACTIONS.SORT_SCOPEITEMS.ERROR: {
      return state.set("error", action.error).set("scopesLoading", false);
    }

    // GET TASKS
    case ACTIONS.TASK.PENDING: {
      return state.set("tasksLoading", true).set("error", "");
    }
    case ACTIONS.TASK.SUCCESS: {
      return state
        .set("tasksLoading", false)
        .set("error", "")
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.TASK.ERROR: {
      return state.set("tasksLoading", false).set("error", action.error);
    }

    // CREATE TASK
    case ACTIONS.CREATE_TASK.PENDING: {
      return state.set("taskLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_TASK.SUCCESS: {
      return state
        .set("taskLoading", false)
        .set("error", "")
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_TASK.ERROR: {
      return state.set("error", action.error).set("taskLoading", false);
    }

    // UPDATE TASK
    case ACTIONS.UPDATE_TASK.PENDING: {
      return state.set("taskLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_TASK.SUCCESS: {
      return state
        .set("taskLoading", false)
        .set("error", "")
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_TASK.ERROR: {
      return state.set("error", action.error).set("taskLoading", false);
    }

    // UPDATE TASK STATUS
    case ACTIONS.UPDATE_TASK_STATUS.PENDING: {
      return state.set("taskLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_TASK_STATUS.SUCCESS: {
      return state
        .set("taskLoading", false)
        .set("error", "")
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_TASK_STATUS.ERROR: {
      return state.set("error", action.error).set("taskLoading", false);
    }

    // DELETE TASK
    case ACTIONS.DELETE_TASK.PENDING: {
      return state.set("taskLoading", true);
    }
    case ACTIONS.DELETE_TASK.SUCCESS: {
      return state
        .set("taskLoading", false)
        .set("error", "")
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_TASK.ERROR: {
      return state.set("taskLoading", false).set("error", action.error);
    }

    // SORT TASKS
    case ACTIONS.SORT_TASKS.PENDING: {
      return state.set("error", "").set("tasksLoading", true);
    }
    case ACTIONS.SORT_TASKS.SUCCESS: {
      return state
        .set("error", "")
        .set("tasksLoading", false)
        .set("tasks", action.data.data)
        .set("taskPagination", action.data.pagination);
    }
    case ACTIONS.SORT_TASKS.ERROR: {
      return state.set("error", action.error).set("tasksLoading", false);
    }

    // RESOURCE SHIFTS
    case ACTIONS.RESOURCE_SHIFTS.PENDING: {
      return state.set("error", "").set("resourceShiftsLoading", true);
    }
    case ACTIONS.RESOURCE_SHIFTS.SUCCESS: {
      return state
        .set("error", "")
        .set("resourceShifts", action.data)
        .set("resourceShiftsLoading", false);
    }
    case ACTIONS.RESOURCE_SHIFTS.ERROR: {
      return state
        .set("error", action.error)
        .set("resourceShiftsLoading", false);
    }

    // RESOURCES MONITOR
    case ACTIONS.RESOURCE_MONITOR.PENDING: {
      return state.set("error", "").set("resourcesMonitorLoading", true);
    }
    case ACTIONS.RESOURCE_MONITOR.SUCCESS: {
      return state
        .set("error", "")
        .set("resourcesMonitor", action.data)
        .set("resourcesMonitorLoading", false);
    }
    case ACTIONS.RESOURCE_MONITOR.ERROR: {
      return state
        .set("error", action.error)
        .set("resourcesMonitorLoading", false);
    }

    // RESOURCE CAPACITY
    case ACTIONS.RESOURCE_CAPACITY: {
      return state.set("resourceCapacity", action.data);
    }

    // GET SCOPE PROGRESS SUMMARY
    case ACTIONS.GET_SCOPE_PROGRESS_SUMMARY.PENDING: {
      return state.set("error", "").set("scopeProgressSummaryLoading", true);
    }
    case ACTIONS.GET_SCOPE_PROGRESS_SUMMARY.SUCCESS: {
      return state
        .set("scopeProgressSummaryLoading", false)
        .set("error", "")
        .set("scopeProgressSummary", action.data);
    }
    case ACTIONS.GET_SCOPE_PROGRESS_SUMMARY.ERROR: {
      return state
        .set("scopeProgressSummaryLoading", false)
        .set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
